







import Vue, { PropType } from 'vue';
import { Location } from 'vue-router';
import Identicon from '../basic/Identicon.vue';

export default Vue.extend({
  name: 'AccountLink',
  props: {
    address: String,
    name: String,
    withIdenticon: {
      type: Boolean,
      default: true,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    route: {
      type: Object as PropType<Location>,
      required: false,
    },
  },
  components: {
    Identicon,
  },
  computed: {
    component() {
      if (this.route && this.address) {
        return 'a';
      }
      return 'div';
    },
    label(): string {
      if (this.name) {
        return this.name;
      }
      if (this.address) {
        return this.address;
      }
      return 'Contract Creation';
    },
    computedRoute(): Location {
      // Add address param to route
      return {...this.route, params: {...(this.route || {}).params, address: this.address}};
    },
    href(): string | null {
      if (!this.route || !this.address) {
        return null;
      }
      const route = this.$router.resolve(
        this.computedRoute,
        this.$router.currentRoute,
      );
      return route.href;
    },
  },
  methods: {
    handleClick() {
      if (this.route && this.address && this.$router) {
        this.$router.push(this.computedRoute);
      }
      this.$emit('click');
    },
  },
});
